import { Link } from 'react-router-dom';
import { LinkIcon } from 'lucide-react';
import { LoginArea } from '@/components/auth/LoginArea';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { nip19 } from 'nostr-tools';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { user } = useCurrentUser();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 border-b bg-background/80 backdrop-blur-sm">
        <div className="container flex h-14 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-bold text-lg">
            <LinkIcon className="size-5 text-primary" />
            <span>Nostr Links</span>
          </Link>

          <div className="flex items-center gap-3">
            {user && (
              <Link
                to={`/${nip19.npubEncode(user.pubkey)}`}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                My Links
              </Link>
            )}
            <LoginArea className="max-w-60" />
          </div>
        </div>
      </header>

      <main className="flex-1">
        {children}
      </main>

      <footer className="border-t py-6">
        <div className="container flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>
            Nostr Links &mdash; Your links, your keys, your data.
          </p>
          <span>
            <a
              href="https://shakespeare.diy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Vibed with Shakespeare
            </a>
            {' and Marc\'s 🍝code'}
          </span>
        </div>
      </footer>
    </div>
  );
}
